import {
    DropdownItem, Layout, PanelProcessLastRun, SlideoutDecorator, SlideoutDecoratorProps, Textbox
} from "@mcleod/components";
import { AutogenLayoutProcessLogViewer } from "./autogen/AutogenLayoutProcessLogViewer";

export class ProcessLogViewer extends AutogenLayoutProcessLogViewer {

    static registerProcessLogViewerHandler(): void {
        PanelProcessLastRun.registerProcessLogViewerHandler((processDescription: string, props?: Partial<SlideoutDecoratorProps>) => {
            ProcessLogViewer.showInSlideoutDecorator(processDescription, props);
        });
    }

    public static showInSlideoutDecorator(processLogDescription: string, props?: Partial<SlideoutDecoratorProps>) {
        const layout = Layout.getLayout("lme/general/ProcessLogViewer") as ProcessLogViewer;

        const forceItemSelection = (textbox: Textbox, item: DropdownItem) => {
            textbox.items = [item];
            textbox.selectedItem = item;
            textbox.enabled = false;
        }

        new SlideoutDecorator({
            layout: layout,
            width: "75%",
            fillVerticalSpace: true,
            title: "Process Log Viewer",
            layoutLoadListeners: () => {
                layout.mainDataSource.orderBy = [{ field: "date_run", sort: "desc"}];
                layout.textboxDateRun.text = "t-90,t";
                layout.textboxUserIdSearch.lookupModelAllowMultiSelect = false;
                forceItemSelection(layout.textboxDescr, new DropdownItem(processLogDescription));

                // displaying "All" because that's what they are used to seeing in classic
                forceItemSelection(layout.textboxProcessType, new DropdownItem("All"));
                // null out datasource to avoid "All" being added to the search filter
                layout.textboxProcessType.dataSource = null;

                layout.mainDataSource.executeValidatedSearch();
            },
            ...props
        })
    }

}
